import React, { useState } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/1.webp';
import hero2 from '../../images/slider/2.webp';
import hero3 from '../../images/slider/3.webp';
import SearchBar from "../SearchBar";

const Hero4 = () => {
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleFilter = (e) => {
    setFilter(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(filter=="renove"){
        navigate(`/riads-renove?query=${query}`);
    }else{

        navigate(`/riads-a-renover?query=${query}`);
    }
  };

  var settings = {
    dots: false,
    arrows: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    fade: true,
  };

  return (
    <section className="wpo-hero-slider wpo-hero-style-3">
      <div className="wpo-line-animated">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="hero-container">
        <div className="hero-wrapper">
          <Slider {...settings}>
            <div className="hero-slide">
              <div className="slide-inner" style={{ backgroundImage: `url(${hero1})` }}>
                <div className="container-fluid">
                  <div className="slide-content">
                    <div className="slide-title">
                      <h2>Bienvenue Chez GET RIAD</h2>
                    </div>
                    <div className="clearfix"></div>
                    <div className="slide-btns">
                      <SearchBar
                        value={query}
                        onChange={handleChange}
                        filter={filter}
                        handleFilter={handleFilter}
                        showType={true}
                        handleSubmit={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-slide">
              <div className="slide-inner" style={{ backgroundImage: `url(${hero2})` }}>
                <div className="container-fluid">
                  <div className="slide-content">
                    <div className="slide-title">
                      <h2>Explorez le luxe des Riads</h2>
                    </div>
                    <div className="clearfix"></div>
                    <div className="slide-btns">
                      <SearchBar
                        value={query}
                        onChange={handleChange}
                        filter={filter}
                        handleFilter={handleFilter}
                        showType={true}
                        handleSubmit={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-slide">
              <div className="slide-inner" style={{ backgroundImage: `url(${hero3})` }}>
                <div className="container-fluid">
                  <div className="slide-content">
                    <div className="slide-title">
                      <h2>Votre Satisfaction Notre Priorité</h2>
                    </div>
                    <div className="clearfix"></div>
                    <div className="slide-btns">
                      <SearchBar
                        value={query}
                        onChange={handleChange}
                        filter={filter}
                        handleFilter={handleFilter}
                        showType={true}
                        handleSubmit={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Hero4;
